(() => {
  function initCreateYourSet(root) {
    if (!root || root.dataset.initialized === 'true') return;

    root.dataset.initialized = 'true';

    const discount =
      Number(root.dataset.discount || 15) / 100;

    const currency =
      root.dataset.currency ||
      window.Shopify?.currency?.active ||
      'EUR';

    const locale =
      document.documentElement.lang || 'en';

    const moneyFormat =
      root.dataset.moneyFormat ||
      window.theme?.moneyFormat ||
      null;

    const tabs = Array.from(
      root.querySelectorAll('[data-set-category-tab]')
    );

    const cards = Array.from(
      root.querySelectorAll('[data-set-product]')
    );

    const slots = Array.from(
      root.querySelectorAll('[data-set-slot]')
    );

    const progressText =
      root.querySelector('[data-set-progress-text]');

    const totals =
      root.querySelector('[data-set-totals]');

    const regularOutput =
      root.querySelector('[data-set-regular]');

    const discountedOutput =
      root.querySelector('[data-set-discounted]');

    const savingOutput =
      root.querySelector('[data-set-saving]');

    const addButton =
      root.querySelector('[data-set-add]');

    const addButtonText =
      root.querySelector('[data-set-add-text]');

    const errorOutput =
      root.querySelector('[data-set-error]');

    const selected = new Map();
    const selectedOrder = [];

    let totalsWasVisible = false;


    /* ======================================================
       MONEY
       ====================================================== */

    function formatMoney(cents) {
  const value =
    Number(cents || 0);

  if (
    window.theme &&
    typeof window.theme.formatMoney === 'function'
  ) {
    return window.theme.formatMoney(
      value,
      moneyFormat || undefined
    );
  }

  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency
    }).format(value / 100);
  } catch (error) {
    return `${(value / 100).toFixed(2)} ${currency}`;
  }
}


    /* ======================================================
       CATEGORIES
       ====================================================== */

    function activateCategory(category) {
      tabs.forEach(tab => {
        tab.classList.toggle(
          'is-active',
          tab.dataset.setCategoryTab === category
        );
      });

      cards.forEach(card => {
        card.classList.toggle(
          'is-hidden',
          card.dataset.category !== category
        );
      });
    }


    /* ======================================================
       PRODUCT / VARIANT READING
       ====================================================== */

    function getVariantElement(card) {
      return card.querySelector(
        '[data-set-variant]'
      );
    }

    function readCard(card) {
      const variantElement =
        getVariantElement(card);

      if (!variantElement) return null;

      let variantId;
      let price;
      let image = '';
      let variantTitle = '';
      let available = false;

      if (variantElement.tagName === 'SELECT') {
        const option =
          variantElement.options[
            variantElement.selectedIndex
          ];

        if (!option) return null;

        variantId = Number(option.value);

        price =
          Number(option.dataset.price || 0);

        image =
          option.dataset.image || '';

        variantTitle =
          option.dataset.title || '';

        available =
          option.dataset.available === 'true';

      } else {
        variantId =
          Number(variantElement.value);

        price =
          Number(
            variantElement.dataset.price || 0
          );

        image =
          variantElement.dataset.image || '';

        variantTitle =
          variantElement.dataset.title || '';

        available =
          variantElement.dataset.available ===
          'true';
      }

      return {
        productId:
          Number(card.dataset.productId),

        title:
          card.dataset.productTitle,

        category:
          card.dataset.category,

        variantId,
        variantTitle,
        price,
        image,
        available
      };
    }


    /* ======================================================
       UPDATE CARD WHEN VARIANT CHANGES
       ====================================================== */

    function updateCardVariant(card) {
      const selection =
        readCard(card);

      if (!selection) return;

      const priceOutput =
        card.querySelector(
          '[data-set-product-price]'
        );

      const image =
        card.querySelector(
          '[data-set-image]'
        );

      const selectButton =
        card.querySelector(
          '[data-set-select]'
        );

      if (priceOutput) {
        priceOutput.textContent =
          formatMoney(selection.price);
      }

      if (
        image &&
        selection.image &&
        image.src !== selection.image
      ) {
        image.src = selection.image;
        image.srcset = '';
      }

      if (selectButton) {
        selectButton.disabled =
          !selection.available;
      }

      const existing =
        selected.get(selection.category);

      if (
        existing &&
        existing.productId ===
          selection.productId
      ) {
        selected.set(
          selection.category,
          selection
        );

        render();
      }
    }


    /* ======================================================
       REMOVE
       ====================================================== */

    function removeCategory(category) {
      selected.delete(category);

      const index =
        selectedOrder.indexOf(category);

      if (index !== -1) {
        selectedOrder.splice(index, 1);
      }

      render();
    }


    /* ======================================================
       SELECT PRODUCT
       ====================================================== */

    function selectCard(card) {
      const selection =
        readCard(card);

      if (
        !selection ||
        !selection.available
      ) {
        return;
      }

      const existing =
        selected.get(selection.category);

      if (
        existing &&
        existing.productId ===
          selection.productId &&
        existing.variantId ===
          selection.variantId
      ) {
        removeCategory(
          selection.category
        );

        return;
      }

      const categoryWasSelected =
        selected.has(selection.category);

      if (
        !categoryWasSelected &&
        selected.size >= 3
      ) {
        return;
      }

      selected.set(
        selection.category,
        selection
      );

      if (!categoryWasSelected) {
        selectedOrder.push(
          selection.category
        );
      }

      render();

      /*
       * Automatically move to the next
       * unselected category.
       */
      if (
        !categoryWasSelected &&
        selected.size < 3
      ) {
        const currentIndex =
          tabs.findIndex(
            tab =>
              tab.dataset.setCategoryTab ===
              selection.category
          );

        const orderedTabs = [
          ...tabs.slice(currentIndex + 1),
          ...tabs.slice(0, currentIndex + 1)
        ];

        const nextTab =
          orderedTabs.find(
            tab =>
              !selected.has(
                tab.dataset.setCategoryTab
              )
          );

        if (nextTab) {
          activateCategory(
            nextTab.dataset.setCategoryTab
          );
        }
      }
    }


    /* ======================================================
       PROGRESS / STATUS
       ====================================================== */

    function renderProgress() {
      const count = selected.size;

      if (!progressText) return;

      if (count === 0) {
        progressText.textContent = '';
        progressText.hidden = true;
        return;
      }

      progressText.hidden = false;

      if (count === 1) {
        progressText.textContent =
          '1 of 3 selected.';
        return;
      }

      if (count === 2) {
        progressText.textContent =
          '2 of 3 selected.';
        return;
      }

      progressText.textContent =
        'Three pieces selected.';
    }


    /* ======================================================
       YOUR SET — PRODUCT SLOTS
       ====================================================== */

    function renderSlots() {
      slots.forEach(
        (slot, index) => {
          const category =
            selectedOrder[index];

          const selection =
            category
              ? selected.get(category)
              : null;

              slot.classList.toggle(
              'is-filled',
              Boolean(selection)
            );
          const empty =
            slot.querySelector(
              '[data-set-slot-empty]'
            );

          const selectedHolder =
            slot.querySelector(
              '[data-set-slot-selected]'
            );

          const categoryLabel =
              slot.querySelector(
                '[data-set-slot-category]'
              );

          const title =
            slot.querySelector(
              '[data-set-slot-title]'
            );

          const variant =
            slot.querySelector(
              '[data-set-slot-variant]'
            );

          const price =
            slot.querySelector(
              '[data-set-slot-price]'
            );

          const regularPrice =
            slot.querySelector(
              '[data-set-slot-regular-price]'
            );

          const imageWrap =
            slot.querySelector(
              '[data-set-slot-image-wrap]'
            );

          const image =
            slot.querySelector(
              '[data-set-slot-image]'
            );

          const remove =
            slot.querySelector(
              '[data-set-remove]'
            );


          /*
           * Empty slot
           */

          if (!selection) {
            if (empty) {
              empty.hidden = false;
            }

            if (categoryLabel) {
            categoryLabel.textContent = '';
          }

            if (selectedHolder) {
              selectedHolder.hidden = true;
            }

            if (imageWrap) {
              imageWrap.hidden = true;
            }

            if (image) {
              image.removeAttribute('src');
              image.alt = '';
            }

            if (title) {
              title.textContent = '';
            }

            if (variant) {
              variant.textContent = '';
            }

            if (price) {
              price.textContent = '';
            }

            if (regularPrice) {
              regularPrice.textContent = '';
            }

            if (remove) {
              remove.hidden = true;
              remove.dataset.category = '';
            }

            return;
          }


          /*
           * Selected slot
           */

          if (empty) {
            empty.hidden = true;
          }

          if (selectedHolder) {
            selectedHolder.hidden = false;
          }

          if (categoryLabel) {
            categoryLabel.textContent =
              selection.category.toUpperCase();
          }

          if (title) {
            title.textContent =
              selection.title;
          }

          if (variant) {
            const showVariant =
              selection.variantTitle &&
              selection.variantTitle !==
                'Default Title';

            variant.textContent =
              showVariant
                ? selection.variantTitle
                : '';
          }


          /*
           * Individual set price
           */

          const discountedPrice =
            selection.price *
            (1 - discount);

          if (price) {
            price.textContent =
              formatMoney(discountedPrice);
          }

          if (regularPrice) {
            regularPrice.textContent =
              formatMoney(selection.price);
          }


          /*
           * Image
           */

          if (
            imageWrap &&
            image &&
            selection.image
          ) {
            image.src = selection.image;
            image.alt = selection.title;
            imageWrap.hidden = false;

          } else if (imageWrap) {
            imageWrap.hidden = true;
          }


          /*
           * Remove
           */

          if (remove) {
            remove.hidden = false;
            remove.dataset.category =
              selection.category;
          }
        }
      );
    }


    /* ======================================================
       PRICE SUMMARY
       ====================================================== */

    function renderTotals() {
      const selections =
        Array.from(selected.values());

      const regular =
        selections.reduce(
          (total, item) =>
            total + item.price,
          0
        );

      /*
       * Calculate each discounted line separately
       * so preview follows the three product rows.
       */
      const discounted =
        regular * (1 - discount);

      const saving =
        regular - discounted;

      if (regularOutput) {
        regularOutput.textContent =
          formatMoney(regular);
      }

      if (discountedOutput) {
        discountedOutput.textContent =
          formatMoney(discounted);
      }

      if (savingOutput) {
        const discountPercent =
          Math.round(discount * 100);

        savingOutput.textContent =
          `SAVE ${formatMoney(saving)} / ${discountPercent}%`;
      }


      /*
       * Pricing summary appears only
       * when the set is complete.
       */

      const isComplete =
        selected.size === 3;

      if (!totals) return;

      if (!isComplete) {
        totals.hidden = true;

        totals.classList.remove(
          'is-entering',
          'is-visible'
        );

        totalsWasVisible = false;

        return;
      }

      totals.hidden = false;


      /*
       * Minimal natural entrance.
       */

      if (!totalsWasVisible) {
        totals.classList.remove(
          'is-visible'
        );

        totals.classList.add(
          'is-entering'
        );

        window.requestAnimationFrame(() => {
          totals.classList.remove(
            'is-entering'
          );

          totals.classList.add(
            'is-visible'
          );
        });

        totalsWasVisible = true;

        return;
      }

      totals.classList.remove(
        'is-entering'
      );

      totals.classList.add(
        'is-visible'
      );
    }


    /* ======================================================
       PRODUCT CARDS
       ====================================================== */

    function renderCards() {
      cards.forEach(card => {
        const selection =
          readCard(card);

        if (!selection) return;

        const button =
          card.querySelector(
            '[data-set-select]'
          );

        const current =
          selected.get(
            selection.category
          );

        const isSelected =
          current &&
          current.productId ===
            selection.productId &&
          current.variantId ===
            selection.variantId;

        card.classList.toggle(
          'is-selected',
          Boolean(isSelected)
        );

        if (button) {
          button.textContent =
            isSelected
              ? 'SELECTED'
              : 'SELECT';

          const maxReached =
            selected.size >= 3 &&
            !selected.has(
              selection.category
            );

          button.disabled =
            !selection.available ||
            maxReached;
        }
      });
    }


    /* ======================================================
       MASTER RENDER
       ====================================================== */

    function render() {
      renderProgress();
      renderSlots();
      renderTotals();
      renderCards();

      const isComplete =
        selected.size === 3;

      if (addButton) {
        addButton.disabled =
          !isComplete;
      }

      if (addButtonText) {
        addButtonText.textContent =
          isComplete
            ? 'ADD YOUR SET'
            : 'SELECT 3 PIECES';
      }
    }


    /* ======================================================
       CATEGORY EVENTS
       ====================================================== */

    tabs.forEach(tab => {
      tab.addEventListener(
        'click',
        () => {
          activateCategory(
            tab.dataset.setCategoryTab
          );
        }
      );
    });


    /* ======================================================
       PRODUCT EVENTS
       ====================================================== */

    cards.forEach(card => {
      const variant =
        getVariantElement(card);

      const button =
        card.querySelector(
          '[data-set-select]'
        );

      if (
        variant &&
        variant.tagName === 'SELECT'
      ) {
        variant.addEventListener(
          'change',
          () => {
            updateCardVariant(card);
          }
        );
      }

      if (button) {
        button.addEventListener(
          'click',
          () => {
            selectCard(card);
          }
        );
      }

      updateCardVariant(card);
    });


    /* ======================================================
       REMOVE EVENTS
       ====================================================== */

    slots.forEach(slot => {
      const remove =
        slot.querySelector(
          '[data-set-remove]'
        );

      if (!remove) return;

      remove.addEventListener(
        'click',
        () => {
          const category =
            remove.dataset.category;

          if (category) {
            removeCategory(category);
          }
        }
      );
    });


    /* ======================================================
       ADD SET TO CART
       ====================================================== */

    if (addButton) {
      addButton.addEventListener(
        'click',
        async () => {
          if (
            selected.size !== 3 ||
            addButton.disabled
          ) {
            return;
          }

          const originalText =
            addButtonText
              ? addButtonText.textContent
              : 'ADD YOUR SET';


          /*
           * Unique ID for this set.
           */

          const setId =
            window.crypto &&
            typeof window.crypto.randomUUID ===
              'function'
              ? window.crypto.randomUUID()
              : `deville-${Date.now()}-${Math.random()
                  .toString(36)
                  .slice(2)}`;


          /*
           * Build the three normal Shopify
           * line items.
           */

          const items =
            selectedOrder.map(
              category => {
                const item =
                  selected.get(category);

                return {
                  id: item.variantId,
                  quantity: 1,

                  properties: {
                    _deville_set:
                      'true',

                    _deville_set_id:
                      setId,

                    _deville_set_category:
                      item.category,

                    _deville_set_discount:
                      '15'
                  }
                };
              }
            );


          /*
           * Loading state.
           */

          addButton.disabled = true;

          if (addButtonText) {
            addButtonText.textContent =
              'ADDING...';
          }

          if (errorOutput) {
            errorOutput.hidden = true;
            errorOutput.textContent = '';
          }


          try {
            /*
             * Add all three line items.
             */

            const response =
              await fetch(
                window.Shopify.routes.root +
                  'cart/add.js',
                {
                  method: 'POST',

                  headers: {
                    'Content-Type':
                      'application/json',

                    'X-Requested-With':
                      'XMLHttpRequest',

                    Accept:
                      'application/json'
                  },

                  body:
                    JSON.stringify({
                      items
                    })
                }
              );

            const result =
              await response.json();

            if (
              !response.ok ||
              result.status
            ) {
              throw new Error(
                result.description ||
                  result.message ||
                  'Unable to add set.'
              );
            }


            /*
             * Keep Broadcast accessibility
             * behavior.
             */

            if (window.a11y) {
              window.a11y.lastElement =
                addButton;
            }


            /*
             * Native Broadcast cart refresh.
             */

            document.dispatchEvent(
              new CustomEvent(
                'theme:cart:refresh',
                {
                  bubbles: true
                }
              )
            );


            /*
             * Success state.
             */

            if (addButtonText) {
              addButtonText.textContent =
                'ADDED';
            }

            window.setTimeout(() => {
              if (addButtonText) {
                addButtonText.textContent =
                  originalText;
              }

              addButton.disabled =
                selected.size !== 3;
            }, 1200);

          } catch (error) {
            console.error(
              'DEVILLE Create Your Set:',
              error
            );

            if (errorOutput) {
              errorOutput.textContent =
                error.message ||
                'Unable to add set.';

              errorOutput.hidden = false;
            }

            if (addButtonText) {
              addButtonText.textContent =
                'TRY AGAIN';
            }

            window.setTimeout(() => {
              if (addButtonText) {
                addButtonText.textContent =
                  originalText;
              }

              addButton.disabled =
                selected.size !== 3;
            }, 1500);
          }
        }
      );
    }


    /* ======================================================
       INITIAL CATEGORY
       ====================================================== */

    const initialTab =
      tabs.find(
        tab =>
          tab.classList.contains(
            'is-active'
          )
      ) || tabs[0];

    if (initialTab) {
      activateCategory(
        initialTab.dataset.setCategoryTab
      );
    }

    render();
  }


  /* ========================================================
     INIT ALL
     ======================================================== */

  function initAll() {
    document
      .querySelectorAll(
        '[data-create-your-set]'
      )
      .forEach(
        initCreateYourSet
      );
  }


  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initAll,
      { once: true }
    );

  } else {
    initAll();
  }


  /*
   * Shopify Theme Editor support.
   */

  document.addEventListener(
    'shopify:section:load',
    event => {
      const root =
        event.target.querySelector(
          '[data-create-your-set]'
        );

      if (root) {
        initCreateYourSet(root);
      }
    }
  );
})();